import { createRoot } from 'react-dom/client'

import { host } from './embed'
import './index.css'
import { Root } from './Root'

// Before the first render: the Media Manager sends its theme and page as soon
// as the frame has loaded, which can be before React has mounted.
if (host) window.addEventListener('message', host.receive)

createRoot(document.getElementById('root')!).render(<Root />)
